//@ts-nocheck

//Components
import ShellLayout from '../../layouts/ShellLayout/ShellLayout';
import shellHeaderBuilder from '../../utils/shellHeaderBuilder';
import TemplatesPanel from '../../components/GlobalSettings/Templates/TemplatesPanel';
import PassengerFieldsPanel from '../../components/GlobalSettings/PassengerFieldsPanel/PassengerFieldsPanel/PassengerFieldsPanel';
import AmenitiesPanel from '../../components/GlobalSettings/AmenitiesPanel/AmenitiesPanel/AmenitiesPanel';
import PaymentPlansPanel from '../../components/GlobalSettings/PaymentPlansPanel/PaymentPlansPanel';
import BrandingPanel from '../../components/GlobalSettings/BrandingPanel/BrandingPanel';
import AccountSettingsPanel from '../../components/GlobalSettings/AccountSettingsPanel/AccountSettingsPanel';
import DiscountCodesPanel from '../../components/GlobalSettings/DiscountCodesPanel/DiscountCodesPanel';

//Other dependencies
import { useTranslation } from 'react-i18next';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useEffect } from 'react';
import { XGTabs } from 'xg-cl';
import * as PropTypes from 'prop-types';
import './GlobalSettings.css';

/**
 * This is the global settings page component.
 *
 * @namespace Pages
 */

const GlobalSettings = ({ id }) => {
  const { t } = useTranslation(['settings', 'common']);
  const {
    enableNewPaymentPlans,
    enableOperatorContactSettings,
    enableDiscountCodes
  } = useFlags();

  // Update page title
  useEffect(() => {
    document.title = 'Nivo - Global Settings';
  }, []);

  const mainHeader = shellHeaderBuilder({
    title: {
      title: t('globalSettings')
    },
    cta: <></>
  });

  const settingsTabs = [
    {
      title: t('passengerFields'),
      content: <PassengerFieldsPanel id='passenger-fields-panel' />
    },
    {
      title: t('amenities'),
      content: <AmenitiesPanel id='amenities-panel' />
    }
  ];

  // Add Payment Options tab only if LaunchDarkly flag is enabled, before Templates
  if (enableNewPaymentPlans) {
    settingsTabs.push({
      title: t('paymentPlan.title'),
      content: <PaymentPlansPanel id='payment-plans-panel' tripId={null} />
    });
  }

  // Templates tab should always come before Branding and Account Settings.
  settingsTabs.push({
    title: t('templates'),
    content: <TemplatesPanel id='templates-panel' isGlobal />
  });

  if (enableDiscountCodes) {
    settingsTabs.push({
      title: t('discountCodes.title', 'Discount Codes'),
      content: <DiscountCodesPanel id='discount-codes-panel' />
    });
  }

  if (enableOperatorContactSettings) {
    settingsTabs.push({
      title: t('branding'),
      content: <BrandingPanel id='branding-panel' />
    });
  }

  settingsTabs.push({
    title: t('accountSettings'),
    content: <AccountSettingsPanel id='account-settings-panel' />
  });

  return (
    <div id={id} data-testid='global-settings-page'>
      <ShellLayout
        id='global-settings-shell'
        data-testid='global-settings-shell'
        headerData={mainHeader}
        isLoadingContent={false}
      >
        <div className='global-settings__wrapper'>
          <XGTabs
            id='global-settings-tabs'
            tabs={settingsTabs}
            className='global-settings-tab-panel'
          />
        </div>
      </ShellLayout>
    </div>
  );
};

GlobalSettings.propTypes = {
  id: PropTypes.string.isRequired
};

export default GlobalSettings;
